import 'react-toastify/dist/ReactToastify.css'

import '@/i18n'
import { ToastContainer } from 'react-toastify'
import { ThemeProvider } from '@material-tailwind/react'
import { RouterProvider } from 'react-router-dom'
import router from '@/router'
import { Provider } from 'react-redux'
import { store } from '@/store'
import { theme } from '@/theme'
import { StyleSheetManager } from 'styled-components'
import isPropValid from '@emotion/is-prop-valid'
import { PermifyProvider } from '@permify/react-role'
import PropTypes from 'prop-types'
import { PlatformVersionProvider } from '@/contexts/platform-version'

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js'

import ChartDataLabels from 'chartjs-plugin-datalabels'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
)

const MainSite = ({ platformVersion }) => {
  return (
    <>
      <ToastContainer style={{ zIndex: 10000 }} />
      <Provider store={store}>
        <StyleSheetManager shouldForwardProp={isPropValid} disableVendorPrefixes={false}>
          <ThemeProvider value={theme}>
            <PermifyProvider>
              <PlatformVersionProvider version={platformVersion}>
                <RouterProvider router={router} />
              </PlatformVersionProvider>
            </PermifyProvider>
          </ThemeProvider>
        </StyleSheetManager>
      </Provider>
    </>
  )
}

MainSite.propTypes = {
  platformVersion: PropTypes.string
}

MainSite.defaultProps = {
  platformVersion: ''
}

export default MainSite
